/** @jsx jsx */

import { Grid, jsx } from "theme-ui"
import { useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"

import Copyright from "@components/Footer/Copyright"
import Navigation from "@components/Footer/Navigation"
import LogoSmall from "@components/LogoSmall"
import useLocaleContext from "@hooks/useLocaleContext"
import ImageLink from "@components/ImageLink"
import Variant from "../Variant"
function Footer() {
  const {
    navigation: { links },
  } = useStaticQuery(graphql`
    query FooterNavQuery {
      navigation: allContentfulFooterNavigation {
        links: nodes {
          appStoreLinks {
            url
            image {
              ...ImageFields
            }
            altText
          }
          title
          node_locale
          items {
            href
            link
            id
            slug
            title
            links {
              href
              id
              slug
              title
            }
          }
        }
      }
    }
  `)

  const locale = useLocaleContext()
  const localizedNavigation = useMemo(
    () => links.find(node => node.node_locale === locale),
    [links, locale]
  )

  return (
    <footer sx={{ background: "black" }}>
      <Variant as="section" variants={["sectionContainer"]}>
        <Variant
          as="div"
          sx={{
            background: "black",
          }}
          variants={["container", "containerSpacingX"]}
        >
          <Grid gap={[10, 12]}>
            <Grid columns={[null, "1fr"]} gap={10}>
              <Navigation links={localizedNavigation} />
            </Grid>
            <div
              sx={{
                height: "1px",
                backgroundColor: "grey.darker",
                width: "100%",
              }}
            />

            <div
              sx={{
                display: "flex",
                justifyContent: localizedNavigation.appStoreLinks
                  ? "space-between"
                  : "center",
                alignItems: "center",
                flexDirection: ["column", "row", "row"],
                gap: [10, 0],
              }}
            >
              {localizedNavigation.appStoreLinks && (
                <div
                  sx={{
                    display: "flex",
                    gap: 6,
                  }}
                >
                  {localizedNavigation.appStoreLinks.map(link => (
                    <ImageLink
                      key={link.url}
                      url={link.url}
                      imageUrl={link.image.file.url}
                      altText={link.altText}
                    />
                  ))}
                </div>
              )}
              <div
                sx={{
                  display: "flex",
                  flexDirection: ["column", "row", "row"],
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 5,
                }}
              >
                <LogoSmall />
                <Copyright />
              </div>
            </div>
          </Grid>
        </Variant>
      </Variant>
    </footer>
  )
}

Footer.propTypes = {}

export default Footer
